import { Box, Flex, Image, Text } from "@chakra-ui/react";
import iconFile from "../../assets/images/projectManagement/file-text (1).svg";
import noImage from "../../assets/images/projectManagement/noImage.png";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconRejected from "../../assets/images/contract/x-circle.svg";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

export const formatTableValue = (value, key, popupFile, data) => {
  switch (key) {
    case "id":
      return <Text>{value}</Text>;
    case "image":
      const isImage = value;
      const path = isImage?.path ? `${baseURL}/${isImage?.path}` : "";

      return (
        <Box>
          {isImage ? (
            <Image width={"100%"} minW={"153px"} h={"86px"} objectFit={"cover"} src={path}></Image>
          ) : (
            // <Box h={"48px"} w={"100%"} backgroundColor={"#D9D9D9"}></Box>
            <Image
              width={"100%"}
              minW={"153px"}
              h={"86px"}
              objectFit={"cover"}
              src={noImage}
            ></Image>
          )}
        </Box>
      );
    case "is_allow_ttkq":
      const is_allow_ttkq = value ? "Cho phép lên TTKQ/VBTT/HĐTHNV" : "";
      return (
        <Text
          minW={"max-content"}
          color={
            value ? "var(--color-status-employ)" : ""
          }
        >
          {is_allow_ttkq}
        </Text>
      );
    case "isProjectMechanismParameters":
      let isProjectMechanismParameters=<></>;
      if (value) {
        isProjectMechanismParameters = (
          <>
            <Image src={iconApproved} />
            <Text minW={"max-content"} color={"var(--color-status-employ)"}>
              Đã cập nhật
            </Text>
          </>
        );
      } else {
        isProjectMechanismParameters = (
          <>
            <Image src={iconRejected} />
            <Text color={"var(--text-red-employee)"}>Chưa cập nhật</Text>
          </>
        );
      }

      return <Flex gap={"8px"}>{isProjectMechanismParameters}</Flex>;
    case "status":
      let content;
      if (value === "OPEN") {
        content = (
          <>
            <Image src={iconApproved} />
            <Text minW={"max-content"} color={"var(--color-status-employ)"}>
              Dự án đang mở
            </Text>
          </>
        );
      } else {
        content = (
          <>
            <Image src={iconRejected} />
            <Text color={"var(--text-red-employee)"}>Dự án đã đóng</Text>
          </>
        );
      }

      return <Flex gap={"8px"}>{content}</Flex>;
    case "nameproject":
      return (
        <Box>
          <Text textAlign={"start"}>{value.name}</Text>
          <Text
            fontSize={"14px"}
            fontWeight={400}
            color={"var(--color-label-employee)"}
            textAlign={"start"}
          >
            {value.des}
          </Text>
        </Box>
      );
    case "investor":
      return <Text textAlign={"start"}>{value}</Text>;
    case "classify":
      return <Text>{value}</Text>;
    case "address":
      return <Text>{value}</Text>;
    case "city":
      return <Text>{value}</Text>;
    case "fileProject":
      return Array.isArray(value) && value.length > 0 ? (
        <Flex flexDirection="column" gap="8px">
            <Flex
              justifyContent="flex-end"
              cursor="pointer"
              onClick={() => popupFile(value)}
            >
              <Image src={iconFile} />
            </Flex>
        </Flex>
      ) : (
        <Text>{value}</Text>
      );
    default:
      return <Text>{value}</Text>;
  }
};
